// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3214":"dcb3ff24","8688":"26f336cd"}[chunkId] + ".chunk.css";
};